<template>
  <div
    class="rfp-rr-rating-snapshot-150-or rr-rating-snapshot"
    :class="{ 'rfp-rr-rating-rtl': isRightToLeftActive }"
  >
    <div class="rfp-rr-rating-snapshot-151-or rr-rating-snapshot-inner">
      <h3 class="rfp-rr-rating-snapshot-152-or rr-sub-title black">{{ headerTitle }}</h3>
      <p>{{ headerSubTitle }}</p>
      <ul>
        <li v-for="item in ratingBarList" :key="item.label" class="rfp-rr-rating-snapshot-153-or">
          <div
            v-tooltip="item.ariaLabel"
            role="button"
            tabindex="0"
            :aria-label="item.ariaLabel"
            @keydown.space.prevent
            @keyup.enter="filterStars(item.label)"
            @keyup.space="filterStars(item.label)"
            @click="filterStars(item.label)"
          >
            <span class="rfp-rr-rating-snapshot-154-or" style="width: 30px; display: inline-block"
              >{{ item.label
              }}<span class="rfp-rr-rating-snapshot-star-157-or">{{ starIcon }}</span></span
            >
            <span class="rfp-rr-rating-snapshot-155-or rr-rating-bar-outer">
              <span
                class="rfp-rr-rating-snapshot-156-or rr-rating-bar-inner"
                :class="{ Enabled: item.count != 0 }"
                :style="{ width: item.Average }"
              ></span> </span
            >{{ item.count }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import { tooltipDirective } from '../../../../../shared/directives/tooltip';

export default {
  name: 'rfp-ratings-rating-snapshot',
  directives: {
    tooltip: tooltipDirective,
  },
  props: {
    headerTitle: {
      type: String,
      required: true,
    },
    headerSubTitle: {
      type: String,
      required: true,
    },
    starIcon: {
      type: String,
      required: true,
    },
    ratingBar: {
      type: Array,
      required: true,
    },
    isRightToLeftActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ratingBarList() {
      return this.ratingBar
        .map((item) => ({
          ...item,
          Average: item.Average.replace(/,/g, '.'),
        }))
        .sort((a, b) => b.label - a.label);
    },
  },
  methods: {
    filterStars(starValue) {
      const filters = ['filterOne', 'filterTwo', 'filterThree', 'filterFour', 'filterFive'];

      if (isNaN(parseInt(starValue, 10)))
        throw new Error(
          'error/rfp-ratings-rating-snapshot#filterStars: invalid value provided for # of stars',
          starValue,
        );

      eventBus.emit(filters[starValue - 1]);
      setTimeout(() => {
        this.$scrollTo('#rare-list-page');
        document
          .querySelector('#rfp-rr-ratings-reviews-results-list')
          ?.focus({ preventScroll: true });
      });
    },
  },
};
</script>
